import {
	ActivateProductionTriggerMutation,
	CreateProductionTriggerMutation,
	DeleteProductionTriggerMutation,
	InactivateProductionTriggerMutation,
	UpdateProductionTriggerMutation
} from "~/gql/mutations/produce/productionTriggers.generated";
import { GetProductionTriggersQuery } from "~/gql/queries/produce/productionTriggers.generated";

export const produceTriggerEndpoints = {
	ActivateProductionTrigger: {
		invalidatesTags: ["ProductionTrigger", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: ActivateProductionTriggerMutation) => res
	},
	CreateProductionTrigger: {
		invalidatesTags: ["ProductionTrigger", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: CreateProductionTriggerMutation) => res
	},
	DeleteProductionTrigger: {
		invalidatesTags: ["ProductionTrigger", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: DeleteProductionTriggerMutation) => res
	},
	GetProductionTriggers: {
		providesTags: ["ProductionTrigger"] as AddTagTypes,
		transformResponse: (res: GetProductionTriggersQuery) => res
	},
	InactivateProductionTrigger: {
		invalidatesTags: ["ProductionTrigger", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: InactivateProductionTriggerMutation) => res
	},
	UpdateProductionTrigger: {
		invalidatesTags: ["ProductionTrigger", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: UpdateProductionTriggerMutation) => res
	}
};
